export default "__VITE_ASSET__IXxziDxq__"